import React from 'react';
import { useLocation } from 'react-router-dom';

const NoMatch = () => {
  const location = useLocation();

  return (
    <div>
      <h3>
        404 No match for
        {' '}
        <code>{location.pathname}</code>
      </h3>
    </div>
  );
};

export default NoMatch;
